import React from 'react';
import { Link } from 'react-router-dom';
import { formatEventDay, eventCountdown, EVENT_TYPE_COLORS } from '../../hooks/useEvents';

// Compact event row — date chip, title, countdown and place. Shared by the
// feed sidebar and Explore's discovery section.
//
// Events have no detail route — there is no /event/:id — so the destination is
// the registration link when there is one and the calendar otherwise. Same rule
// heroSlots.eventSlot uses, so an event leads to the same place from every
// surface. External links get a real anchor with noopener; internal ones get a
// Link. registration_url is CHECKed to ^https:// at the DB layer (031), which
// is what makes it safe as an href.
const EventListItem = ({ event }) => {
  const { month, day } = formatEventDay(event.startsAt);
  const accent = EVENT_TYPE_COLORS[event.type] || 'var(--brand-primary)';
  const where = event.isVirtual ? (event.location || 'Virtual') : event.location;

  const body = (
    <>
      <div
        className="w-11 flex-shrink-0 rounded-lg flex flex-col items-center justify-center py-1.5"
        style={{ backgroundColor: 'var(--pill-bg)', border: '1px solid var(--pill-border)' }}
      >
        <span className="text-[10px] font-bold leading-none tracking-wide" style={{ color: accent }}>{month}</span>
        <span className="text-base font-bold leading-tight text-primary">{day}</span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold line-clamp-2 leading-snug text-primary group-hover:text-brand-accent transition-colors">
          {event.title}
        </p>
        <p className="text-xs text-tertiary mt-0.5 truncate">
          {[eventCountdown(event.startsAt), where].filter(Boolean).join(' · ')}
        </p>
      </div>
    </>
  );

  const className = 'flex gap-3 items-center cursor-pointer group';

  return event.registrationUrl ? (
    <a href={event.registrationUrl} target="_blank" rel="noopener noreferrer" className={className}>
      {body}
    </a>
  ) : (
    <Link to="/explore/events" className={className}>{body}</Link>
  );
};

export default EventListItem;
